define.alias("shared/components/shared/post/secondary/saved-captions/editor", "calendar/components/shared/post/secondary/saved-captions/editor");